
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./adapters/application.ts"
import * as amdModule1 from "./config/abilities.ts"
import * as amdModule2 from "./config/environment.ts"
import * as amdModule3 from "./data/async-setter.ts"
import * as amdModule4 from "./data/handlers/auth-handler.ts"
import * as amdModule5 from "./data/handlers/debug-handler.ts"
import * as amdModule6 from "./data/handlers/type-normalizer-handler.ts"
import * as amdModule7 from "./data/json-api.ts"
import * as amdModule8 from "./data/normalizers/jsonapi-document.ts"
import * as amdModule9 from "./data/normalizers/jsonapi-normalizer.ts"
import * as amdModule10 from "./data/normalizers/text.ts"
import * as amdModule11 from "./data/normalizers/url-normalizer.ts"
import * as amdModule12 from "./deprecation-workflow.ts"
import * as amdModule13 from "./router.ts"
import * as amdModule14 from "./serializers/application.ts"
import * as amdModule15 from "./services/ability.ts"
import * as amdModule16 from "./services/session.ts"
import * as amdModule17 from "./services/store.ts"
import * as amdModule18 from "./initializers/load-bootstrap-config.js"
import * as amdModule19 from "./instance-initializers/global-ref-cleanup.js"
import * as amdModule20 from "./services/-ensure-registered.js"
import * as amdModule21 from "./services/page-title.js"
import * as amdModule22 from "./templates/application.gts"
import * as amdModule23 from "./routes/application.ts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"@efdigital/ll-xceed-v2/adapters/application": amdModule0,
"@efdigital/ll-xceed-v2/config/abilities": amdModule1,
"@efdigital/ll-xceed-v2/config/environment": amdModule2,
"@efdigital/ll-xceed-v2/data/async-setter": amdModule3,
"@efdigital/ll-xceed-v2/data/handlers/auth-handler": amdModule4,
"@efdigital/ll-xceed-v2/data/handlers/debug-handler": amdModule5,
"@efdigital/ll-xceed-v2/data/handlers/type-normalizer-handler": amdModule6,
"@efdigital/ll-xceed-v2/data/json-api": amdModule7,
"@efdigital/ll-xceed-v2/data/normalizers/jsonapi-document": amdModule8,
"@efdigital/ll-xceed-v2/data/normalizers/jsonapi-normalizer": amdModule9,
"@efdigital/ll-xceed-v2/data/normalizers/text": amdModule10,
"@efdigital/ll-xceed-v2/data/normalizers/url-normalizer": amdModule11,
"@efdigital/ll-xceed-v2/deprecation-workflow": amdModule12,
"@efdigital/ll-xceed-v2/router": amdModule13,
"@efdigital/ll-xceed-v2/serializers/application": amdModule14,
"@efdigital/ll-xceed-v2/services/ability": amdModule15,
"@efdigital/ll-xceed-v2/services/session": amdModule16,
"@efdigital/ll-xceed-v2/services/store": amdModule17,
"@efdigital/ll-xceed-v2/initializers/load-bootstrap-config": amdModule18,
"@efdigital/ll-xceed-v2/instance-initializers/global-ref-cleanup": amdModule19,
"@efdigital/ll-xceed-v2/services/-ensure-registered": amdModule20,
"@efdigital/ll-xceed-v2/services/page-title": amdModule21,
"@efdigital/ll-xceed-v2/templates/application": amdModule22,
"@efdigital/ll-xceed-v2/routes/application": amdModule23,
  },
  exportFastbootModules
);
